import React, { useState } from 'react';
import { Modal, Image, Button } from 'react-bootstrap';
import './criteriaModal.scss';

interface PropsObject {
    showModal: boolean,
    callBack: (action: boolean) => void
}

const CriteriaModal = (props: PropsObject) => {
    const [guideLines, setGuideLines] = useState<{ title: string, content: string }[]>(
        [
            {
                title: 'Format',
                content: 'Please submit your photo in either JPEG or PNG format only.'
            },
            {
                title: 'Size',
                content: 'The photo should have a minimum resolution of 1024x1024 pixels or higher.This ensures that the image is clear and well-defined.'
            },
            {
                title: 'Background',
                content: 'Choose a plain, neutral-coloured background, such as white or gray. A simple backdrop without distractions keeps the focus on you.'
            },
            {
                title: 'Dress code',
                content: 'Wear professional attire that reflects our company’s standards. This could be a collared shirt, blouse, or other business-appropriate clothing.'
            },
            {
                title: 'Pose',
                content: 'Your photo should be a headshot, with your shoulders visible and your face directly facing the camera. This pose ensures that your photo is both professional and identifiable.'
            },
        ]
    )


    return (
        <Modal
            show={props?.showModal}
            dialogClassName="criteria-modal"
            backdrop="static"
            keyboard={false}
            scrollable
            centered
            onHide={() => props?.callBack(false)}
        >
            <Modal.Header closeButton className='crt-header'>
                <Modal.Title>Update your profile photo</Modal.Title>
            </Modal.Header>
            <Modal.Body className='crt-body'>
                <div className='d-flex align-items-center crt-banner'>
                    <Image src='/images/criteria_modal/criteria-banner.png' alt='Criteria Banner' />
                    <p>We are in the process of updating our internal records and need your assistance to ensure we have a current photo for each employee.</p>
                </div>
                <div className='d-flex flex-column sub-guide'>
                    <h6>Submission Guidelines</h6>
                    <ul className='mt-3 mb-0'>
                        {guideLines?.map((res, ind) => (
                            <li key={ind}>
                                <div className='d-flex guide-line-cont'>
                                    <span className='cus-marker'></span>
                                    <div className='d-flex flex-column guide-line'>
                                        <h6>{res?.title}</h6>
                                        <p>{res?.content}</p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className='d-flex flex-column photo-cont'>
                        <h6>Photo Reference</h6>
                        <div className='mt-3'>
                            <Image src='/images/criteria_modal/crt-smpl-one.png' alt='Sample Image' />
                            <Image src='/images/criteria_modal/crt-smpl-two.png' alt='Sample Image' />
                            <Image src='/images/criteria_modal/crt-smpl-three.png' alt='Sample Image' />
                            <Image src='/images/criteria_modal/crt-smpl-four.png' alt='Sample Image' />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='crt-footer'>
                <Button variant='dark' className='upload-btn' onClick={() => props?.callBack(true)}>Upload profile photo</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CriteriaModal;